var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSocialFansly28(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.304 6c-1.272.054-2.564.456-3.519 1.324C3.681 8.288 3.16 9.75 3 11.172v.451a5.052 5.052 0 0 0 1.44 3.265c2.575 2.612 5.176 5.198 7.776 7.783.489.482.94 1.015 1.537 1.37h.444c.657-.227 1.061-.828 1.556-1.277 1.914-1.952 3.91-3.822 5.778-5.818l-5.603-5.623c.632-.634 1.258-1.275 1.9-1.897.524-.518 1.253-.817 1.993-.757 1.503.02 2.748 1.557 2.472 3.035-.162 1.282-1.37 1.98-2.123 2.903l1.893 1.805c.63-.519 1.221-1.154 1.758-1.77 1.497-1.763 1.573-4.537.203-6.397-.896-1.306-2.411-2.117-3.98-2.245h-.777c-1.16.131-2.305.57-3.168 1.372-2.598 2.534-5.141 5.124-7.742 7.654-.603-.593-1.202-1.19-1.801-1.787-.636-.632-.973-1.57-.787-2.459.255-1.321 1.616-2.314 2.956-2.092 1.292.137 1.986 1.377 2.917 2.121l1.873-1.778C12.35 7.545 10.778 6.111 8.791 6h-.488Zm5.75 8.308c1.265.014 2.48 1.017 2.61 2.305.252 1.6-1.275 3.175-2.886 2.956-1.573-.055-2.721-1.776-2.328-3.263a2.606 2.606 0 0 1 2.061-1.941c.18-.04.362-.059.543-.057Zm-.028.92a1.699 1.699 0 1 0 1.533.967.725.725 0 0 1-1.142-.591.725.725 0 0 1 .073-.311 1.698 1.698 0 0 0-.464-.065Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialFansly28);
export default __webpack_public_path__ + "static/media/social-fansly_28.ff75a093.svg";
export { ForwardRef as ReactComponent };